import { useCallback, useState } from 'react';

export const useDataColumns = (
  comparator: (a: string, b: string) => number,
): {
  dataColumns: string[];
  addColumns: (newColumns: string[]) => void;
  reset: () => void;
} => {
  const [dataColumns, setDataColumns] = useState<string[]>([]);
  const addColumns = useCallback(
    (newColumns: string[]) => {
      setDataColumns((oldColumns) => {
        return updateColumns(oldColumns, newColumns, comparator);
      });
    },
    [setDataColumns, comparator],
  );
  const reset = useCallback(() => {
    setDataColumns([]);
  }, [setDataColumns]);

  return {
    dataColumns,
    addColumns,
    reset,
  };
};

const updateColumns = (
  oldColumns: string[],
  newColumns: string[],
  comparator: (a: string, b: string) => number,
) => {
  const columnsSet = new Set(oldColumns);

  newColumns.forEach((column) => {
    columnsSet.add(column);
  });

  return Array.from(columnsSet).sort(comparator);
};
